import CustomAdditionalSettingsReducer from "@tLinc/Store/Reducer/AdditionalSettingsReducer";
import DiscontinuedToastReducer from "@tLinc/Store/Reducer/DiscontinuedToastReducer";
import CustomMyProductsDataReducer from "@tLinc/Store/Reducer/MyProductsInfoReducer";
import CustomDataReducer from "@tLinc/Store/Reducer/ShipTosInfoReducer";
import { combineReducers } from "redux";

const customDataReducerData = {
    shipTosReducer: CustomDataReducer,
    myProductsReducer: CustomMyProductsDataReducer,
    discontinuedProductToastReducer: DiscontinuedToastReducer,
    additionalSettingsReducer: CustomAdditionalSettingsReducer,
};

export type DataReducers = typeof customDataReducerData;

const customDataReducer = combineReducers(customDataReducerData as any);

export default customDataReducer;
